import { Component, ViewEncapsulation } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ToasterWrapperComponent } from '@generic/toaster-wrapper';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToasterWrapperComponent, RouterLink],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent {
  title = 'elaad';
}
